import type { TourStepConfig } from "../types";

export const interfaceTourSteps: TourStepConfig[] = [
  {
    title: "Добро пожаловать в Metrica Pro!",
    description:
      "Система мониторинга и аналитики энергоресурсов. Давайте познакомимся с интерфейсом.",
    placement: "center",
  },
  {
    title: "Навигация",
    description:
      "Используйте боковое меню для перехода между разделами: мониторинг, аналитика, отчёты.",
    tourTargetId: "nav-dashboard",
    placement: "right",
  },
  {
    title: "Описание страниц",
    description:
      "На каждой странице есть иконка ⓘ рядом с заголовком. Нажмите на неё, чтобы узнать назначение страницы.",
    tourTargetId: "page-help-icon",
    placement: "bottom",
  },
  {
    title: "Нужна помощь?",
    description:
      "Кнопка поддержки всегда доступна внизу справа. Напишите нам — ответим и в системе, и в Telegram.",
    tourTargetId: "support-float-button",
    placement: "left",
  },
];
